module.exports = __webpack_public_path__ + "static/img/brief-ction2.51bae38.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/brief-ction2.jpg
// module id = vWcq
// module chunks = 1